module.exports = {
  logo: {
    large: '/paceimages/alpha-logo-large.jpg',
    small: '/paceimages/alpha-logo-small.jpg',
  },
  illustration: {
    login: '/images/login_illustration.png',
    no_data: '/illustrations/search.svg',
  },
  currency: '₹',
  selectedLob: 'Health',
  colorPalettePie: [
    '#00ACAC',
    '#005095',
    '#4D0092',
    '#8F0035',
    '#B03C00',
    '#FFBC00',
    '#424242',
  ],
  colorPaletteBar: ['#005095', '#00ACAC'],
};
